export default __webpack_public_path__ + "static/media/truck-fast.122b2a9e.png";